<template lang="html">
    <transition
        :name="
            invert
                ? vertical
                    ? 'fade-tab-vertical-invert'
                    : 'fade-tab-invert'
                : vertical
                ? 'fade-tab-vertical'
                : 'fade-tab'
        "
    >
        <div v-if="active" class="con-tab vs-tabs--content">
            <slot />
        </div>
    </transition>
</template>

<script>
export default {
    name: 'vx-tab',
    inheritAttrs: false,
    props: {
        label: {
            default: 'Label',
            type: String
        },
        icon: {
            default: '',
            type: String
        },
        tag: {
            default: '',
            type: String
        },
        iconPack: {
            type: String,
            default: 'material-icons'
        },
        classList: {
            type: [String, Object, Array]
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        vertical: false,
        active: false,
        invert: false,
        childMetadata: {
            label: null,
            id: null,
            icon: null,
            iconPack: null,
            tag: null,
            class: null,
            listeners: {},
            disabled: false,
            attrs: {}
        }
    }),
    watch: {
        updateRequiringProperties: {
            handler: function (val) {
                this.updateChild()
            },
            deep: true
        }
    },
    computed: {
        updateRequiringProperties() {
            return {
                ...this.$attrs,
                classList: this.classList,
                disabled: this.disabled,
                label: this.label
            }
        },
        tabIndex() {
            return this.$parent.children.findIndex((f) => f.id == this._uid)
        },
        isDisplayed() {
            return this.$parent.children.contains(this.childMetadata)
        }
    },
    methods: {
        updateChild() {
            Object.assign(this.childMetadata, {
                label: this.label,
                id: this._uid,
                icon: this.icon,
                iconPack: this.iconPack,
                tag: this.tag,
                class: this.classList,
                listeners: this.$listeners,
                disabled: this.disabled,
                attrs: this.$attrs
            })

            if (!this.isDisplayed) {
                this.$parent.children.push(this.childMetadata)
            }
        }
    },
    mounted() {
        this.updateChild()
    }
}
</script>
